import { Heading } from '@radix-ui/themes';
import { t } from 'i18next';

export const CommonStepHeader = (props: { label: string }) => (
  <Heading size="4">{t(props.label)}</Heading>
);
